import React from 'react'

import CompanyInfoSection from './CompanyInfoSection'

const UserTypeSection = ({
  isLegal,
  handleLegalToggle,
  formData,
  handleInputChange,
  errors,
}) => (
  <>
    <h2 className="text-[19px] font-semibold text-slate-800 mb-4 mt-8">
      მომხმარებლის ტიპი
    </h2>
    <div
      className={`inline-block border rounded-xl transition-all duration-300 ${
        isLegal
          ? 'bg-red-50 border-red-200'
          : 'bg-slate-50 border-slate-200 hover:border-red-200 hover:bg-red-50'
      }`}
    >
      <label className="flex items-center cursor-pointer p-3">
        <div className="relative">
          <input
            type="checkbox"
            checked={isLegal}
            onChange={handleLegalToggle}
            className="sr-only"
          />
          <div
            className={`w-5 h-5 rounded-md border flex items-center justify-center transition-all duration-300 ${
              isLegal
                ? 'bg-citrus-red border-citrus-red text-white'
                : 'bg-white border-slate-300'
            }`}
          >
            {isLegal && <span className="text-sm font-bold">✓</span>}
          </div>
        </div>
        <span className="ml-3 text-slate-800 text-[15px]">იურიდიული პირი</span>
      </label>
    </div>
    {isLegal && (
      <CompanyInfoSection
        formData={formData}
        handleInputChange={handleInputChange}
        errors={errors}
      />
    )}
  </>
)

export default UserTypeSection
